'use client';

import { useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import {
  LoadingSplashScreen,
  LoginForm,
  SplashScreen,
  StyledGridBox,
  StyledHeader,
  StyledLoginFormBox,
  StyledTextCall,
  StyledThemeButtonBox,
  // ProvidersLogin
} from '~/entities';
import { type AuthProviders, ThemeButton } from '~/features';
import { isStaging } from '~/shared';

export function LoginView({
  callbackUrl,
  errorParam,
}: {
  callbackUrl: string;
  errorParam?: string;
}) {
  const router = useRouter();
  const [isSubmitting, setIsSubmitting] = useState<`${AuthProviders}` | null>(
    null
  );

  return (
    <StyledGridBox>
      {!!isSubmitting && <LoadingSplashScreen isSubmitting={isSubmitting} />}
      <StyledThemeButtonBox>
        <ThemeButton />
      </StyledThemeButtonBox>
      <SplashScreen />
      <StyledLoginFormBox>
        <Image
          className="mobile-logo"
          src="/static/logo_martins_ads.svg"
          alt="Logo da Martins Ads"
          width={100}
          height={103}
        />
        <StyledHeader variant="h1">Acesse e gerencie campanhas</StyledHeader>
        <StyledTextCall>
          {isStaging()
            ? 'Para entrar na sua conta digite seu usuário e senha.'
            : 'Para entrar na sua conta digite o código MFA e aprove no app de autenticação.'}
        </StyledTextCall>

        <LoginForm
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          callbackUrl={callbackUrl}
          errorParam={errorParam}
          onRecoveryRequest={() => router.push('/recuperacao-senha')}
        />
        {/* <ProvidersLogin
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          callbackUrl={callbackUrl}
        /> */}
      </StyledLoginFormBox>
    </StyledGridBox>
  );
}
